/** @format */

import React from "react";

export default () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1365 1506"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <rect width="1365" height="1506" fill="#F9F7F2" />
      <g filter="url(#filter0_d)">
        <path d="M912 986H1326V1041H912V986Z" fill="#979797" />
      </g>
      <g filter="url(#filter1_d)">
        <path d="M40 531H683V644H40V531Z" fill="#F2F0EB" />
      </g>
      <path d="M40 665H362V926H40V665Z" fill="#F2F0EB" />
      <path d="M45 781H357V791H45V781Z" stroke="#F9F7F2" strokeWidth="10" />
      <g filter="url(#filter2_d)">
        <path d="M382 665H684V926H382V665Z" fill="#F2F0EB" />
      </g>
      <path
        d="M180.23 588.508V589.562H176.703V588.508H180.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path
        d="M218.23 606.508V607.562H214.703V606.508H218.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path
        d="M160.23 721.508V722.562H156.703V721.508H160.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path
        d="M165.23 739.508V740.562H161.703V739.508H165.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path
        d="M160.23 853.508V854.562H156.703V853.508H160.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path
        d="M165.23 871.508V872.562H161.703V871.508H165.23Z"
        fill="#332F2F"
        fillOpacity="0.8"
      />
      <path d="M262 1070H659V1409H262V1070Z" fill="#C4C4C4" />
      <path d="M262 1070H659V1123H262V1070Z" fill="#979797" />
      <g filter="url(#filter3_d)">
        <path d="M262 1409H659V1491H262V1409Z" fill="#F2F0EB" />
      </g>
      <path d="M707 1070H1104V1409H707V1070Z" fill="#C4C4C4" />
      <path d="M707 1070H1104V1123H707V1070Z" fill="#979797" />
      <g filter="url(#filter4_d)">
        <path d="M707 1409H1104V1491H707V1409Z" fill="#F2F0EB" />
      </g>
      <g filter="url(#filter5_d)">
        <path d="M737 531H1326V967H737V531Z" fill="#F2F0EB" />
      </g>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="737"
        y="531"
        width="592"
        height="344"
      >
        <rect
          width="592"
          height="344"
          transform="matrix(1 0 0 -1 737 875)"
          fill="#979797"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect
          x="666.623"
          y="521.62"
          width="732.755"
          height="368.393"
          fill="#979797"
        />
      </g>
      <g clipPath="url(#clip1)">
        <rect
          width="214.394"
          height="42.8788"
          transform="translate(1057 898)"
          fill="#C4C4C4"
        />
        <rect
          x="1057"
          y="898"
          width="214.394"
          height="42.8788"
          rx="2"
          stroke="white"
        />
      </g>
      <rect x="45" y="986" width="639" height="57" fill="#C4C4C4" />
      <path
        d="M696.542 174.982L695.824 174.49C696.253 173.893 696.476 173.278 696.494 172.645V171.503H697.731V172.494C697.731 172.954 697.618 173.415 697.39 173.875C697.166 174.335 696.884 174.704 696.542 174.982Z"
        fill="#F9F7F2"
      />
      <path d="M-1 0H1365V236H-1V0Z" fill="#4E4848" />
      <g filter="url(#filter6_dd)">
        <rect x="-1" y="234" width="1365" height="207" fill="#E6E4DF" />
      </g>
      <g filter="url(#filter7_d)">
        <path
          d="M1059.01 304.062L1224.01 304.062L1224.01 341.062L1059.01 341.062L1059.01 304.062Z"
          fill="#C4C4C4"
        />
      </g>
      <rect x="1239.02" y="304.082" width="87" height="37" fill="#959191" />
      <rect x="40" y="294" width="639" height="36" fill="#C4C4C4" />
      <rect x="40" y="345" width="639" height="36" fill="#C4C4C4" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="912"
        y="986"
        width="414"
        height="57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="39"
        y="531"
        width="645"
        height="115"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="381"
        y="665"
        width="304"
        height="263"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d"
        x="261"
        y="1409"
        width="399"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d"
        x="706"
        y="1409"
        width="399"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d"
        x="736"
        y="531"
        width="591"
        height="438"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_dd"
        x="-3"
        y="232"
        width="1369"
        height="211"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow"
          result="effect2_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d"
        x="1059.01"
        y="304.062"
        width="165"
        height="39"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.016 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect width="1365" height="1506" fill="white" />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="214.394"
          height="42.8788"
          fill="white"
          transform="translate(1057 898)"
        />
      </clipPath>
    </defs>
  </svg>
);
